import {$t} from "@/i18n";

export default class Model {
    constructor() {
        this.personForm = {
            name: "",
            surname: "",
            address_country_code: "",
            region_code: "",
            area_id: 1,
            avatar_data: null,
            avatar: null,
            append_settings: {
                terms_and_conditions: 1,
                setup_role: "",
                newsletter: 1,
                setup_profile: 1,
                hear_about: '',
                hear_about_other: '',
                use_option: ''
            }
        }
        this.languageCode = 'en_GB'
        this.useOptionLocked = false

        this.companyForm = {
            "address_country_code": "",
            "name": "",
            "team_size": "",
            "append_settings": {
                "accounting_software": [],
                "other_software": ""
            },
            "area_id": "" //onsave
        }
        this.personErrors = {
            name: null,
            surname: null,
            role: null,
            use_option: null
        }
        this.companyErrors = {
            teamSize: null,
            name: null
        }
        this.countryErrors = {
            country: null
        }
    }

    setAddressCountryCode(value) {
        this.personForm.address_country_code = value
        this.companyForm.address_country_code = value
        this.countryErrors.country = null
    }

    setRegionCode(value) {
        this.personForm.region_code = value
    }

    setName(value, validate = true) {
        this.personForm.name = value
        this.personErrors.name = null
    }

    getName() {
        return this.personForm.name
    }

    validateName() {
        if (this.getName() === '') {
            this.personErrors.name = $t('First name is required')
        }
    }

    getNameError() {
        return this.personErrors.name
    }

    setCompanyName(value) {
        this.companyForm.name = value
        this.companyErrors.name = null
        this.validateCompanyName()
    }

    getCompanyName() {
        return this.companyForm.name
    }

    validateCompanyName() {
        if (this.getCompanyName() === '') {
            this.companyErrors.name = $t('Name is required')
        }
    }

    getCompanyNameError() {
        return this.companyErrors.name
    }

    setCompanyTeamSize(value) {
        this.companyForm.team_size = value
        this.companyErrors.teamSize = null
    }

    getCompanyTeamSize() {
        return this.companyForm.team_size
    }

    getCountryError() {
        return this.countryErrors.country
    }

    getCompanyTeamSizeError() {
        return this.companyErrors.teamSize
    }

    validateCompanyTeamSize() {
        if (!this.companyForm.team_size) {
            this.companyErrors.teamSize = $t('Team size is required')
        }
    }

    setNewsLetter(value) {
        this.personForm.append_settings.newsletter = value ? 1 : 0
    }

    getNewsLetter() {
        return this.personForm.append_settings.newsletter
    }

    setSurname(value) {
        this.personForm.surname = value
        this.personErrors.surname = null
    }

    getSurname() {
        return this.personForm.surname
    }

    validateSurname() {
        if (this.personForm.surname === '') {
            this.personErrors.surname = $t('Surname is required')
        }
    }

    getSurnameError() {
        return this.personErrors.surname
    }

    setAreaId(value) {
        this.personForm.area_id = value
        this.companyForm.area_id = value
    }

    getAreaId() {
        return this.personForm.area_id
    }

    setAvatarData(value) {
        this.personForm.avatar_data = value
        this.personForm.avatar = value.thumbnail_url
    }

    setAvatar(value) {
        this.personForm.avatar = value
    }

    getAvatar() {
        return this.personForm.avatar
    }

    getAddressCountryCode() {
        return this.personForm.address_country_code
    }

    getLanguageCode() {
        return this.languageCode
    }

    setLanguageCode(value) {
        this.languageCode = value
    }

    validateForm() {
        this.validateName()
        this.validateSurname()
        this.validateUseOption()
    }

    validateCompanyForm() {
        this.validateCompanyName()
        this.validateCompanyTeamSize()
    }

    validateCountryForm() {
        if (!this.personForm.address_country_code) {
            this.countryErrors.country = $t('Required field')
        }
    }

    isCountryFormValid() {
        return !Object.values(this.countryErrors).find(x => x !== null)
    }

    isCompanyFormValid() {
        return !Object.values(this.companyErrors).find(x => x !== null)
    }

    isFormValid() {
        return !Object.values(this.personErrors).find(x => x !== null)
    }

    getPersonForm() {
        return this.personForm
    }

    getCompanyForm() {
        return this.companyForm
    }

    setUseOption(value) {
        this.personForm.append_settings.use_option = value
        this.personErrors.use_option = null
        this.companyForm.append_settings.use_option = value
        this.companyForm.use_option = null
        if (value === 'team') {
            this.personForm.append_settings.setup_role = 'Manager'
        } else if (value === 'solo') {
            this.personForm.append_settings.setup_role = 'Solo'
        }
    }

    getUseOption() {
        return this.personForm.append_settings.use_option
    }

    validateUseOption() {
        if (!this.personForm.append_settings.use_option) {
            this.personErrors.use_option = $t('Field is required')
        }
    }

    getUseOptionError() {
        return this.personErrors.use_option
    }

    getUseOptions() {
        return [
            {
                testId: 'SIGN_UP_USE_TEAM',
                value: 'team',
                title: $t('Team'),
                description: $t('I will use Uku to work together with two or more teammates.')
            },
            {
                testId: 'SIGN_UP_USE_SOLO',
                value: 'solo',
                title: $t('Solo'),
                description: $t('I will use Uku by myself. This plan is free, but the features are limited.'),
            }
        ]
    }

    lockUseOption(lockedValue) {
        // user must not pick use option, rather it is set by the system
        this.setUseOption(lockedValue)
        this.useOptionLocked = true
    }

    getHearAboutText() {
        if (this.personForm.append_settings.hear_about === 'other') {
            return this.personForm.append_settings.hear_about_other
        } else {
            return this.personForm.append_settings.hear_about
        }
    }

    setHearAbout(value) {
        this.personForm.append_settings.hear_about = value
    }

    setHearAboutOther(value) {
        this.personForm.append_settings.hear_about_other = value
    }

    getHearAboutOther() {
        return this.personForm.append_settings.hear_about_other
    }

    getHearAboutOptions() {
        return [
            {
                title: 'Google',
                value: 'google'
            },
            {
                title: 'Facebook',
                value: 'facebook'
            },
            {
                title: 'LinkedIn',
                value: 'linkedin'
            },
            {
                title: $t('Media'),
                value: 'media'
            },
            {
                title: $t('Through integration partner'),
                value: 'integration_partner'
            },
            {
                title: $t('Referral by friend'),
                value: 'referral_by_friend'
            },
            {
                title: $t('Other'),
                value: 'other'
            }
        ]
    }

    getHearAbout() {
        return this.personForm.append_settings.hear_about
    }

    toggleSoftwareSelect(software) {
        const index = this.companyForm.append_settings.accounting_software.indexOf(software);
        if (index >= 0) {
            this.companyForm.append_settings.accounting_software.indexOf(software);
        } else {
            this.companyForm.append_settings.accounting_software.push(software);
        }
    }

    getUsingSoftware() {
        return this.companyForm.append_settings.accounting_software
    }

    setOtherSoftware(value) {
        this.companyForm.append_settings.other_software = value
    }

    getOtherSoftware() {
        return this.companyForm.append_settings.other_software
    }

    getSoftwareOptions() {
        if (this.personForm.region_code === "ee") {
            return [
                "Merit Aktiva",
                "SmartAccounts",
                "Directo",
                "SimplBooks",
                "ERPLY Books",
                "Standard Books",
                "Taavi",
                "e-arveldaja",
            ];
        } else if (this.personForm.region_code === "pl") {
            return [
                'mKsiegowa',
                'enova365',
                '360 Księgowość',
                'wfirma',
                'Aplikacja Ramzes',
                "QuickBooks",
            ]
        } else if (this.personForm.region_code === "dk") {
            return [
                "e-conomic",
                "Xero",
                "QuickBooks",
                "FreshBooks",
                "Sage One",
                "Zoho Books",
                "GoProposal",
                "GoCardless",
            ]
        } else {
            return [
                "Xero",
                "QuickBooks",
                "FreeAgent",
                "FreshBooks",
                "Sage One",
                "Zoho Books",
                "GoProposal",
                "GoCardless",
                "e-conomic",
            ];
        }
    }
}